module.exports = __webpack_public_path__ + "img/ae.42d71570.svg";